import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { PermissionService } from 'src/app/auth/services/permission.service';
import { AccessLevel } from 'src/app/auth/types/access-level';

@Directive({
  selector: '[requireAccess]',
  standalone: false,
})
export class RequireAccessDirective {
  rendered = false;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainerRef: ViewContainerRef,
    private permissionService: PermissionService,
  ) {}

  @Input() set requireAccess(level: AccessLevel | undefined) {
    const hasAccess = !!level && this.permissionService.hasAccess(level);

    if (hasAccess && !this.rendered) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.rendered = true;
    } else if (!hasAccess && this.rendered) {
      this.viewContainerRef.clear();
      this.rendered = false;
    }
  }
}
